export const jobs = {
    namespaced: true,
    state:{
        searchInput: null
    },
    getters:{
        getSearchInput(state){
            // console.log("search -", state.searchInput)
            return state.searchInput
        }
    },
    mutations:{
        updateSearchInput(state, searchInput){        
            state.searchInput = {...(state.searchInput || {}), ...searchInput};
        },
        setSearchInput(state, searchInput){
            state.searchInput = searchInput
        },    
        removeFilter(state, searchFilter) {
            state.searchInput.filters = state.searchInput.filters.filter(filter => filter !== searchFilter);
        }
  
    },
    actions: {
        updateSearchInput({commit}, data){
            commit('updateSearchInput', data)
        },
         setSearchInput({commit}, data){
            commit('setSearchInput', data)
        },
         removeFilter({commit}, data){
            commit('removeFilter', data)
        },
    }
}